import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { calculationMethodList, dateComparisonList, FR_SUFFIX, measurementUnitList, readonlyTypeList } from "../../entities/Constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import Utils from "../../utilities/Utils";
import { DialogBase, Props, State } from "./DialogBase";


export class DialogForReadonlyComponent extends DialogBase<Props,State> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);
 }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Field properties for " + this.props.ele.ENUTitle : "Field properties for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.fieldProperties()}
                </Dialog>
            </>
        );
        return html;
    }

    fieldProperties = () => {
        let htmlString = [];

        htmlString.push(
            <div>
                {this.updateBindingFieldHtml()}

                {this.questionHintHtml()}

                {this.tooTipHtml()}

                {this.errorMessageHtml()}


                {/* <div style={{ display: "flex" , marginTop:'10px' }}>
                    <div style={{ width: '15%' }}>Binding Business Component</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.ele.LoadBindBase} onChange={(e) => {
                        this.props.ele.LoadBindBase = e.target.value;
                        this.props.callback();
                    }}></InputText></div>
                </div>

                <div style={{ display: "flex" , marginTop:'10px' }}>
                    <div style={{ width: '15%' }}>Binding BC Field</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.ele.LoadBindName} onChange={(e) => {
                        this.props.ele.LoadBindName = e.target.value;
                        this.props.callback();
                    }}></InputText></div>
                </div> */}
            </div>
        )

        let subSection = this.props.ele.parent as FormSubSections;

        let allCalculableTypeFieldList = subSection.ListOfFormSectionElements.filter(p => p.Datatype == 'Date' || p.Datatype == 'Currency' || p.Datatype == 'Number');
        let previousFieldList = subSection.ListOfFormSectionElements?.filter(p => p.Sequence < this.props.ele.Sequence);

        htmlString.push(
            <div>
                <div style={{ display: this.props.ele.Datatype == 'Date' || this.props.ele.Datatype == 'Currency' || this.props.ele.Datatype == 'Number' ? "flex" : 'none', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Value Type</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown className="ontario-dropdown"
                            options={readonlyTypeList}
                            optionLabel='label' optionValue='val'
                            value={this.props.ele.ValueType}
                            onChange={(e) => {
                                this.props.ele.ValueType = e.value;
                                this.props.callback();
                            }}></Dropdown></div>
                </div>

                <div style={{ display: this.props.ele.ValueType == 'constant' || (this.props.ele.Datatype !== 'Date' && this.props.ele.Datatype !== 'Currency' && this.props.ele.Datatype !== 'Number') ? 'flex' : 'none', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Constant Value</div>
                    <div style={{ display: 'block', width: '60%' }}>
                        <InputText className="ontario-input" value={this.props.ele.Value}
                            onChange={(e) => {
                                this.props.ele.Value = e.target.value;
                                this.props.callback();
                            }}></InputText></div>
                </div>

                <div style={{
                    display: this.props.ele.ValueType == 'calculate' &&
                        (this.props.ele.Datatype == 'Number' || this.props.ele.Datatype == 'Currency') ? 'block' : 'none', marginTop: '10px'
                }}>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Binding Name</div>
                        <div style={{ display: 'block', width: '60%' }}>
                            {/* @ts-ignore */}
                            <Dropdown className="ontario-dropdown" options={allCalculableTypeFieldList} optionLabel='ENUTitle' optionValue='LoadBindName' value={this.props.ele.DecidingField1}
                                onChange={(e) => {
                                    this.props.ele.DecidingField1 = e.value;
                                    this.props.callback();
                                }}></Dropdown>
                        </div>
                    </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Calculation</div>
                        <div style={{ display: 'block', width: '60%' }}>
                            {/* @ts-ignore */}
                            <Dropdown className="ontario-dropdown" options={calculationMethodList} optionLabel='label' optionValue='val' value={this.props.ele.CalculationMethod}
                                onChange={(e) => {
                                    this.props.ele.CalculationMethod = e.value;
                                    this.props.callback();
                                }}></Dropdown>
                        </div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Deciding Field</div>
                        <div style={{ display: 'block', width: '60%' }}>
                            {/* @ts-ignore */}
                            <Dropdown className="ontario-dropdown" options={allCalculableTypeFieldList} optionLabel='ENUTitle' optionValue='LoadBindName' value={this.props.ele.DecidingField2}
                                onChange={(e) => {
                                    this.props.ele.DecidingField2 = e.value;
                                    this.props.callback();
                                }}></Dropdown>
                        </div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Measure Unit</div>
                        <div style={{ display: 'block', width: '60%' }}>
                            {/* @ts-ignore */}
                            <Dropdown className="ontario-dropdown" options={measurementUnitList} optionLabel='label' optionValue='val' value={this.props.ele.MeasurementUnit}
                                onChange={(e) => {
                                    this.props.ele.MeasurementUnit = e.value;
                                    this.props.callback();
                                }}></Dropdown>
                        </div>
                    </div>
                </div>

                {this.scriptHtml()}

                <div style={{ display: previousFieldList.length < 1 ? 'none' : 'flex', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Trigger Field</div>
                    <div style={{ display: 'block', width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown className="ontario-dropdown" options={previousFieldList} optionLabel='ENUTitle' optionValue='LoadBindName' value={this.props.ele.ScriptTriggerField}
                            onChange={(e) => {
                                this.props.ele.ScriptTriggerField = e.value;
                                this.props.callback();
                            }}></Dropdown>
                    </div>
                </div>
            </div>
        )
        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
